import FilterModal from './FilterModal';
import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetSubscriptionReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useSubscriptionFilters } from '@/store/slices/reportFiltersSlice';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useSubscriptionFilters();
  const { search } = usePublicState();

  const searchValue = search?.subscriptionReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="subscriptionReportSearch" />

      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'SUBSCRIPTION_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetSubscriptionReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}
